import { StyleSheet } from 'aphrodite';
import COLORS from '../../library/colors';

const Color = require('color');

const styles = StyleSheet.create({
  root: {
    maxWidth: 364,
    margin: '124px auto',
    display: 'flex',
    flexDirection: 'column'
  },
  content: {
    padding: 24,
    boxShadow: '0 1px 8px rgba(0,0,0,0.08)',
    background: 'white',
    borderRadius: 3,
    marginBottom: 16,
    marginTop: 32
  },
  title: {
    fontSize: 48,
    textAlign: 'center'
  },
  description: {
    fontSize: 14,
    paddingTop: 16,
    color: COLORS.paperText,
    textAlign: 'center',
    maxWidth: 264,
    margin: '0 auto',
    lineHeight: '18px'
  },
  input: {
    width: '100%',
    fontSize: 16,
    padding: 16,
    marginBottom: 16,
    borderRadius: 4,
    border: 'none',
    outline: 'none',
    paddingLeft: 16 + 32,
    background: 'rgba(0,0,0,0.04)',
    '::placeholder': {
      color: '#c2c2c2'
    },
    ':hover': {
      background: 'rgba(0,0,0,0.06)',
    },
    ':focus': {
      background: 'rgba(0,0,0,0.06)',
    }
  },
  inputIconContainer: {
    position: 'absolute',
    width: 48,
    height: 48,
    left: 0,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputIcon: {
    color: 'rgba(0,0,0,0.12)',
    textAlign: 'center',
    fontSize: 16
  },
  forgottenPasswordLink: {
    color: `${Color(COLORS.kgGreen).darken(0.12)}`,
    transition: '150ms',
    textAlign: 'center',
    padding: 24,
    ':hover': {
      cursor: 'pointer',
      color: `${Color(COLORS.kgGreen).darken(0.24)}`,
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/login/re-authenticate-styles.js